import { config, authHeader } from '../helpers'
import { handleHttpResponse } from '../helpers';

export const TimeSeriesService = {
    loadTimeSeries,
}

function loadTimeSeries({clientID, variableIDs, selectedSCE, timeframes, directions, podID, dateFrom, date, aggregation, needAllDates, needBenchmarkingCurve, needCostEstimations, needOverallConsumptions, needIndividualRegistersData = true}) {
    const query = `{
        timeSeries(clientID: ${JSON.stringify(clientID)},
        variableIDs: ${JSON.stringify(variableIDs)},
        sceList: ${JSON.stringify(selectedSCE)}
        timeframes: ${JSON.stringify(timeframes)}
        directions: ${JSON.stringify(directions)}
        podID: ${JSON.stringify(podID)},
        dateFrom: ${JSON.stringify(dateFrom)},
        date: ${JSON.stringify(date)},
        aggregation: ${JSON.stringify(aggregation)},
        calculateBenchmarking: ${needBenchmarkingCurve ? needBenchmarkingCurve : false},
        getCostEstimations: ${false}) {
            ${needAllDates ? `allDates` : ``}
            registers {
                ${needIndividualRegistersData ? `consumptions` : ''}
                ${needCostEstimations ? `costPerPeriod` : ``}
                variableID
                timeframe
                variableName
                firstPeriodIsComplete
                lastPeriodIsComplete
                indexOfFirstCons
                indexOfLastCons
            }
            eventsForChart {
                event {
                    id
                    category
                    type
                    description
                    date
                }
                index
            }
            ${needOverallConsumptions ? `overallConsumptions` : ``}
            ${needBenchmarkingCurve ? `benchmarkingCurve` : ``}
            hasHighFrequencyData
        }
      }`;
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/graphql', ...authHeader() },
        body: query
    };
    return fetch(`${config.apiUrl}/graphql`, requestOptions).then(response => {
        return handleHttpResponse(response)
        .then(data => data.timeSeries);
      })
  }